import { FormGroup, Label, Input } from 'reactstrap';
import PropTypes from 'prop-types';

const InputRadio = ({
  id,
  name,
  checked,
  value,
  handleChange,
  disabled = false,
  onClick = undefined,
  label,
  radioRight,
  placeholder = undefined,
}) => {
  const classNames = ['custom-radio'];

  if (radioRight) classNames.push('right');

  return (
    <FormGroup check className={classNames.join(' ')}>
      <Input
        id={id}
        type="radio"
        name={name}
        checked={checked}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        onClick={onClick}
        className={placeholder ? 'placeholder' : ''}
      />

      <Label for={id}>{label}</Label>
    </FormGroup>
  );
};

InputRadio.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  className: PropTypes.string,
  small: PropTypes.bool,
};

InputRadio.defaultProps = {
  checked: false,
  label: null,
  className: '',
  small: false,
};

export default InputRadio;
